<template>
  <v-list dense nav>
    <!-- Especiais -->
    <v-subheader class="overline">{{ $t("specialLists") }} </v-subheader>
    <template v-for="item in listEspecial">
      <v-list-item
        exact
        v-if="item.show"
        :key="item.label"
        @click="$router.push(item.route).catch(() => {})"
        :input-value="item.isRouteActive"
      >
        <v-list-item-icon>
          <template v-if="item.icon_img">
            <img class="mb-0" width="24px" :src="item.icon_img" />
          </template>
          <v-icon v-else :class="item.class">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            :class="item.icon_img ? 'text-uppercase' : ''"
            v-text="item.label"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>
<script>
export default {
  name: "special-menu-list",
  data: () => ({
    listEspecial: [],
  }),
  mounted() {
    const nameSport = this.$store.getters.getNameSportById("6046");
    const hasIcon = this.$permissions().customIcons.specials;
    const baseUrlS3IconsSpecial = `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/img/custom/icons/special`;
    this.listEspecial = [
      // BRAZIL
      {
        label: this.$t("brazil"),
        route: {
          name: "category",
          params: {
            sport: "6046",
            category: "35",
          },
          query: {
            sport: nameSport,
            category: this.$t("brazil"),
          },
          hash: "#scrollTop",
        },
        icon_img: hasIcon
          ? `${baseUrlS3IconsSpecial}/special_brazil_50.png`
          : false,
        icon: "mdi-soccer",
        class: "",
        show: true,
      },
      // AMÉRICA DO SUL
      {
        label: this.$t("southAmerica"),
        route: {
          name: "countries",
          params: {
            sport: 6046,
          },
          query: {
            sport: nameSport,
            category: this.$t("southAmerica"),
          },
          hash: "#scrollTop",
        },
        icon_img: hasIcon
          ? `${baseUrlS3IconsSpecial}/special_southamerica_50.png`
          : false,
        icon: "mdi-soccer",
        class: "",
        show: true,
      },
      // UEFA
      {
        label: "UEFA",
        route: {
          name: "countries",
          params: {
            sport: 6046,
          },
          query: {
            sport: nameSport,
            category: "UEFA",
          },
          hash: "#scrollTop",
        },
        icon_img: hasIcon
          ? `${baseUrlS3IconsSpecial}/special_uefa_50.png`
          : false,
        icon: "mdi-soccer",
        class: "",
        show: true,
      },
      // EUROPA
      {
        label: this.$t("europe"),
        route: {
          name: "countries",
          params: {
            sport: 6046,
          },
          query: {
            sport: nameSport,
            category: this.$t("europe"),
          },
          hash: "#scrollTop",
        },
        icon_img: hasIcon
          ? `${baseUrlS3IconsSpecial}/special_europe_50.png`
          : false,
        icon: "mdi-soccer",
        class: "",
        show: true,
      },
      // INTERNACIONAL
      {
        label: this.$t("international"),
        route: {
          name: "category",
          params: {
            sport: "6046",
            category: "125",
          },
          query: {
            sport: nameSport,
            category: this.$t("international"),
          },
          hash: "#scrollTop",
        },
        icon_img: hasIcon
          ? `${baseUrlS3IconsSpecial}/special_international_50.png`
          : false,
        icon: "mdi-soccer",
        class: "",
        show: true,
      },
    ];

    this.makeTabActive(this.$route.query.category);
  },

  watch: {
    $route(route) {
      this.makeTabActive(route.query.category);
    },
  },

  methods: {
    makeTabActive(categoryName) {
      this.listEspecial = this.listEspecial.map((item) => {
        if (item.route.query.category === categoryName) {
          return { ...item, isRouteActive: true };
        } else {
          return { ...item, isRouteActive: false };
        }
      });
    },
  },
};
</script>
